import { last } from 'ramda';

/**
 * @param {Array<import('./types').Notification>} state
 * @return {import('./types').Notification}
 */
export const getLastNotification = state => last(state.toastNotifications);
